import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ConfigService} from '@iw-shop/config/service/config.service';
import {setNotification} from '@store/actions/global.actions';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {setConfig} from '@store/actions/config.action';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class AppInitConfigDbService {

    private readonly isBrowser: boolean;

    constructor(
        private store: Store<AppState>,
        private configService: ConfigService,
        @Inject(PLATFORM_ID) platformId: Object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    init() {
        console.log('init config db');
        return new Promise<void>((resolve, reject) => {
            this.configService.loadConfig().subscribe(
                {
                    next: (r) => {
                        if (r.result?.configs.data[0]) {
                            this.store.dispatch(setConfig({config: r.result?.configs.data[0]}))
                        } else {
                            this.store.dispatch(setNotification({
                                notification: 'Die Konfiguration konnte nicht geladen werden.',
                                notificationType: 'error'
                            }));
                        }
                        resolve();
                    },
                    error: (e) => {
                        console.log('reject load config');
                        reject(e);
                    }
                }
            )
        });
    }
}
